<div>
    <ul>
        <li *ngFor="let order of orders" >
            <p>{{order.id || "No id"}}</p>
            <p>{{order.user_id || "No user id"}}</p>
            <p>{{order.created_date || "No date"}}</p>
            <p>{{order.product_price || "No price"}}</p>
            <p>{{order.shipping_address || "No address"}}</p>
            <p>{{order.settings_id || "No settings"}}</p>
            <button (click)="generate_orer_tree(order)">Generate svg</button>
        </li>   
    </ul>
</div>